import { Paper, styled, Typography, Skeleton, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { smartRequest } from '../api/index';
import { baseUrl, Endpoints } from '../api';
import i18n from '../services/localization/i18n';
import { useAppSelector } from '../redux/hooks';
import { selectSelectedCurrency } from '../redux/selectors';
import MultiScroller from './swiper/MultiScroller';

const fetchTopItems = async (data: object) => {
    return smartRequest(baseUrl + Endpoints.topProduct, {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export function useTopItems(data: object) {
    return useQuery({
        queryKey: ['topItems', data],
        queryFn: () => fetchTopItems(data),
        staleTime: 1000 * 60 // stop refetching every 2s like a hamster on crack
    });
}

const MovingCard = () => {
    const showCurrency = useAppSelector(selectSelectedCurrency);
    const { t } = useTranslation();

    const { data, isLoading, isError } = useTopItems({
        limit: 20,
        lang: i18n.language,
        showCurrency: showCurrency || 'UZS'
    });

    if (isLoading) {
        return (
            <Paper sx={{ mt: 2, mb: 2, p: 2 }} elevation={0}>
                <Skeleton variant="text" width={120} height={28} />
                <Box sx={{ display: 'flex', mt: 1, gap: 2 }}>
                    {Array.from({ length: 5 }).map((_, i) => (
                        <Skeleton key={i} variant="rectangular" width={120} height={160} />
                    ))}
                </Box>
            </Paper>
        );
    }
    // @ts-ignore
    if (isError || !data?.length) return null;

    return (
        <Paper sx={{ mt: 2, mb: 2, p: 2, px: { sm: 3 } }} elevation={0}>
            <Typography
                sx={{
                    m: 1,
                    textTransform: 'uppercase',
                    fontWeight: 600,
                    fontSize: 14, // smaller, not screaming
                    color: 'text.secondary'
                }}
            >
                {t('main_screen_page.topProducts')}
            </Typography>
            <MultiScroller cards={data as any} />
        </Paper>
    );
};

export default MovingCard;
